module.exports = __webpack_public_path__ + "static/media/ED_2022-23_Report_Case_Study_Report.8f9cb5be.pdf";